<router-outlet></router-outlet>

<simple-notifications></simple-notifications>

